import { details } from '../../../api/common';
import { printOut } from '../components/print/print';
import * as analytics from '../../../analytics';
import { showNotificationLayer } from '../../../actions/notification';

const _command = params =>
  async dispatch => {
    try
    {
      dispatch(
        showNotificationLayer('Gerando arquivo. Aguarde...')
      );

      const [serviceDetail, voterDetail] =
        await Promise.all([
          details({ id: params.id, path: 'atendimento.php' }),
          details({ id: params.electorId, path: 'eleitor.php' }),
        ]);

      printOut({
        data: {
          service: serviceDetail.data,
          voter: voterDetail.data,
        },
        fileName: `atendimento-${serviceDetail.data.reference}.html`,
      });
    }
    catch(error)
    {
      dispatch(
        showNotificationLayer('Ops... não conseguimos gerar o arquivo.')
      )
    }
  }

export const generatePrint = params => {
  //ga
  analytics.registerEvent({
    category: analytics.categories.service,
    action: analytics.actions.servicePrint,
  });

  return _command(params);
}
